import { space, mediaQueries, fontSizes } from 'style/config';
import { PRODUCT_SLOT_GAP } from 'components/Catalog/ProductGrid/CompareModal/constants';

export const zoneStyles = {
    zoneSection: {
        display: 'flex',
        flexDirection: 'column',
        gap: `${space[2]}px`,
        paddingBottom: 0,
        minWidth: '100%'
    },
    accordionCustomStyles: {
        headerContainer: {
            paddingTop: space[2],
            paddingBottom: space[2],
            justifyContent: 'flex-start',
            alignItems: 'center',
            gap: `${space[2]}px`
        },
        descriptionContainer: {
            overflow: 'visible'
        },
        headerText: {
            fontSize: fontSizes.base,
            width: 'auto !important',
            [mediaQueries.sm]: {
                fontSize: fontSizes.md
            }
        },
        contentContainer: {
            width: '100%',
            marginLeft: 0,
            marginRight: 0,
            paddingBottom: '16px !important'
        }
    },
    productsContainer: {
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: `${PRODUCT_SLOT_GAP}px`,
        alignItems: 'flex-stretch',
        width: '100%',
        [mediaQueries.xsMax]: {
            display: 'flex',
            width: 'max-content',
            minWidth: '100%'
        },
        [mediaQueries.sm]: {
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            width: '100%'
        }
    },
    productSlot: {
        flex: '1 1 auto',
        display: 'flex',
        flexDirection: 'column',
        gap: `${space[4]}px`,
        scrollSnapAlign: 'start',
        minWidth: 0,
        [mediaQueries.xsMax]: {
            flexShrink: 0,
            width: `calc((100vw - ${space[4] * 2}px - ${PRODUCT_SLOT_GAP}px) / 2)`,
            minWidth: `calc((100vw - ${space[4] * 2}px - ${PRODUCT_SLOT_GAP}px) / 2)`
        }
    },
    productSlotCompact: {
        gap: `${space[2]}px`
    },
    zoneContent: {
        display: 'flex',
        flexDirection: 'column',
        gap: `${space[2]}px`,
        flex: 1,
        minHeight: 0,
        minWidth: 0
    },
    subsectionContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: `${space[4]}px`,
        paddingBottom: `${space[4]}px`
    }
};
